export default __webpack_public_path__ + "images/CV.f579a50.png";